"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Modal = _interopRequireDefault(require("./Modal.style"));
var _Label = _interopRequireDefault(require("../Label"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let Modal = (_dec = (0, _reactJss.default)(_Modal.default), _dec(_class = class Modal extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mountStyle: props.visibility
    };
    this.transitionEnd = this.transitionEnd.bind(this);
    this.onModalClick = this.onModalClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }
  static getDerivedStateFromProps(props) {
    if (!props.visibility) {
      return {
        mountStyle: false
      };
    }
    return {
      show: true
    };
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.visibility && this.state.show) {
      setTimeout(() => this.setState({
        mountStyle: true
      }), 10);
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }
  transitionEnd() {
    const {
      visibility
    } = this.props;
    if (!visibility) {
      this.setState({
        show: false
      });
    }
  }
  onModalClick(e) {
    e.stopPropagation();
  }
  onKeyDown(e) {
    const {
      onClose
    } = this.props;
    const isEsc = e.key === 'Escape';
    if (isEsc) onClose();
  }
  render() {
    const {
      classes,
      className,
      size,
      id,
      children,
      label,
      onClose,
      strict,
      dataTestId
    } = this.props;
    const {
      mountStyle: visible,
      show
    } = this.state;
    const bgClasses = (0, _clsx.default)(classes.bg, {
      visible
    });
    const modalClasses = (0, _clsx.default)(className, classes[size], classes.modal, {
      visible
    });
    return show ? /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: bgClasses,
      onTransitionEnd: this.transitionEnd,
      onMouseDown: onClose,
      "data-testid": dataTestId ? `${dataTestId}-container` : undefined
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: modalClasses,
      onMouseDown: this.onModalClick,
      "data-testid": dataTestId
    }, label ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.label
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      fontWeight: "semibold",
      fontSize: "large",
      value: label
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.button,
      onClick: onClose
    }, "Cancel")) : null, strict ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.content
    }, children) : children)) : null;
  }
}) || _class);
Modal.defaultProps = {
  visibility: true,
  size: 'medium',
  onClose: () => {}
};
var _default = exports.default = Modal;